import { render, staticRenderFns } from "./FirmsNavItem.vue?vue&type=template&id=2c7a499c"
import script from "./FirmsNavItem.vue?vue&type=script&lang=js"
export * from "./FirmsNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports